import PropTypes from "prop-types";
import { brand } from "brand/theme";

// ==============================|| LOGO ICON (collapsed rail) ||============================== //

export default function LogoIcon({ dark = false }) {
  return (
    <img
      src={brand.iconUrl}
      alt={brand.name}
      style={{
        height: 35,
        width: "auto",
        maxWidth: 59,
        display: "block",
        objectFit: "contain",
        filter: dark ? "brightness(0) invert(1)" : "none",
      }}
    />
  );
}

LogoIcon.propTypes = { dark: PropTypes.bool };
